export const LEGAL = `© ${new Date().getFullYear()} Hopper`;

export const PRIVACY_LINK = "https://hopper.com/legal/privacy-policy ";
export const TERMS_AND_CONDITIONS_LINK =
  "https://hopper.com/legal/terms-and-conditions ";
